import { useAddAlert } from '@/hooks/useAddAlert'
import { FC, useState } from 'react'
import { checkPromoCode } from '../../utils/api'
import TextField from '@pages/Admin/CourseSettings/components/TextField/TextField'
import SecondaryButton from '@pages/Admin/CourseSettings/components/SecondaryButton/SecondaryButton'
import { Spin } from 'antd'
import classNames from 'classnames'
import cn from './index.module.css'
import { LoadingOutlined } from '@ant-design/icons'

interface IPromoCodeField {
  code: IPromoCodeDiscount | null
  setCode: (code: IPromoCodeDiscount | null) => void
}

const PromoCodeField: FC<IPromoCodeField> = ({ code, setCode }) => {
  const addAlert = useAddAlert()

  const [isPromoCodeChecking, setIsPromoCodeChecking] = useState<boolean>(false)
  const [promoCodeName, setPromoCodeName] = useState<string>('')

  const checkCode = async () => {
    setIsPromoCodeChecking(true)
    const discount = await checkPromoCode(promoCodeName)
    setCode(discount)

    if (!discount) {
      addAlert({
        title: 'Промокод недействителен',
        text: 'Убедитесь, что промокод введен правильно.',
        type: 'error',
      })
    }
    setIsPromoCodeChecking(false)
  }

  return (
    <div className={cn.promoWrapper}>
      <TextField
        className={classNames(cn.field, code && cn.fieldAccept)}
        value={code?.name ?? promoCodeName}
        placeholder="Введите промокод"
        onChange={setPromoCodeName}
        disabled={!!code}
      />
      {!code && (
        <SecondaryButton
          className={cn.promoButton}
          onClick={checkCode}
          disabled={!promoCodeName || isPromoCodeChecking}
        >
          {isPromoCodeChecking && (
            <Spin
              className={cn.loadingIcon}
              indicator={
                <LoadingOutlined
                  spin
                  onPointerEnterCapture={undefined}
                  onPointerLeaveCapture={undefined}
                />
              }
            />
          )}
          Активировать
        </SecondaryButton>
      )}
    </div>
  )
}

export default PromoCodeField
